import React from "react";
import { Redirect  } from "react-router-dom";
import Cookies from "js-cookie";

const AuthGuard = ({ children }) => {
  const token = Cookies.get("vaghfnamaUser");

  if (!token) {
    return <Redirect  to="/auth/login" replace />;
  }

  return children;
};

export default AuthGuard;
